var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card-text", { staticClass: "black--text" }, [
    _c("h1", { staticClass: "mb-3" }, [_vm._v("Více informací o cookies")]),
    _c("h2", { staticClass: "mb-1" }, [_vm._v("Co je to cookie?")]),
    _c("p", [
      _vm._v(
        'Jako cookies, resp. cookie, se v protokolu HTTP označuje textový soubor – malé množství dat, která servery pošlou prohlížeči. Ten je uloží na počítači uživatele. Při každé další návštěvě stránek pak prohlížeč tato data posílá zpět serveru. Cookies běžně slouží k rozlišování jednotlivých uživatelů, ukládá se do nich typicky obsah "nákupního košíku" v e-shopu, uživatelské předvolby a další. Technicky jde o sérii kódů, podle kterých prohlížeč shromažďuje a následně odesílá informace o vašem chování zpět na příslušný server. Cookies obsahují informaci o tom, jak dlouho je má prohlížeč uchovávat (od jednorázových až po několikaleté). Cookies nejsou přímo vázány na vaše jméno ani e-mailovou adresu, často ale obsahují vaše přihlašovací údaje do systému. Jsou společné pro jednu instalaci prohlížeče. Cookies nejsou nijak zabezpečeny, a to včetně shromážděných údajů.'
      )
    ]),
    _c("h2", { staticClass: "mb-1" }, [_vm._v("Jaké cookies používáme?")]),
    _c("p", [
      _vm._v(
        "Používáme cookies třetích stran, konkrétně Google Analytics pro analýzu návštěvnosti. Tyto cookies jsou řízeny třetími stranami a nemáme přístup ke čtení nebo zápisu těchto dat. O podmínkách užití Google Analytics se můžete dočíst "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage",
            target: "_blank"
          }
        },
        [_vm._v("zde")]
      )
    ]),
    _c("h2", { staticClass: "mb-1" }, [_vm._v("Co můžete?")]),
    _c("p", [
      _vm._v(
        'Soubory cookies můžete odmítnout nebo v případě potřeby vymazat. Pokyny, jak to udělat, najdete v sekci "Nápověda" vašeho webového prohlížeče.'
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }